import React from "react";
import authImage from "../../assets/images/auth-image.png";
import SectionHeader from "../../components/ui/HeaderSection";
import PlainNavbar from "../../components/layout/PlainNavbar";
import InputField from "../../components/ui/InputField";
import Button from "../../components/ui/Button";

const ResetPassword = () => {
  return (
    <>
      <PlainNavbar />
      <div className="flex min-h-screen">
        {/* Gambar di sebelah kiri */}
        <div className="w-2/3 hidden lg:block overflow-hidden h-screen">
          <img
            src={authImage}
            alt="Auth"
            className="w-full h-screen object-cover object-left-top"
          />
        </div>

        {/* Form Login */}
        <div className="w-full lg:w-1/2 flex flex-col justify-start px-10 mt-10">
          {/* Header with left alignment */}
          <div className="text-left mt-20">
            <SectionHeader
              title="Masukkan Password Baru Anda"
              description="Masukkan detail akun Anda untuk melanjutkan"
              TitleColor="#010203"
              DescriptionColor="#ABABAB"
              textAlign="left"
            />
          </div>

          {/* Form */}
          <div className="mt-6 space-y-4">
            <InputField
              title="Password Baru"
              placeholder="Masukkan Password Baru Anda"
              type="password"
            />
            <InputField
              title="Ulangi Password Anda"
              placeholder="Ulangi password baru Anda"
              type="password"
            />
          </div>

          {/* Button Login */}
          <div className="mt-6 w-full">
            <Button text="Reset Password" fullWidth={true} className="w-full" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
